import * as React from "react";

import { JoinFormUi, useCustomerSession } from "../../Common";

import { useReactMyBagInitialState } from "../providers";

export const JoinOurRewardsProgram: React.FunctionComponent = () => {
  const { isCustomerLoggedIn } = useCustomerSession();
  const { initialState } = useReactMyBagInitialState();

  const wasTheCustomerLoggedInInitially = React.useMemo(() => {
    const { isCustomerLoggedIn: wasTheCustomerLoggedInInitially } =
      initialState || {};
    return wasTheCustomerLoggedInInitially || false;
  }, [initialState]);
  enum Present {
    Nothing = "nothing",
    JoinForm = "join-form",
    SuccessfullyJoined = "successfully-joined",
  }
  const present = React.useMemo(() => {
    if (isCustomerLoggedIn && wasTheCustomerLoggedInInitially) {
      return Present.Nothing;
    } else if (isCustomerLoggedIn && !wasTheCustomerLoggedInInitially) {
      return Present.SuccessfullyJoined;
    }
    return Present.JoinForm;
  }, [isCustomerLoggedIn, wasTheCustomerLoggedInInitially]);
  if (present === Present.Nothing) {
    return null;
  }
  return (
    <section className={`join-our-rewards-program ${present}`}>
      <h2>{`Join Our Rewards Program`}</h2>

      <div className="why">
        <p>{`Not a Reward member? Create a profile to: `}</p>

        <ul>
          <li>
            <p>{`Track your order.`}</p>
          </li>
          <li>
            <p>{`Get exclusive offers and discounts.`}</p>
          </li>
        </ul>
      </div>

      {present === Present.JoinForm && (
        <JoinFormUi
          useInitialState={useReactMyBagInitialState}
          presentationOfTnc="short-form-tnc"
          scrollSelectorBase={`
            [data-bbnt-new-checkout-2022-mybag] 
            > section.order-loyalty-support 
            > .loyalty-and-support .join-our-rewards-program 
            > .bbnt-common-join-form-ui
          `}
        />
      )}
      {present === Present.SuccessfullyJoined && (
        <div className="you-have-successfully-joined">
          <p>{`You have successfully joined`}</p>
        </div>
      )}
    </section>
  );
};
